module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-group"
  }, [_c('div', {
    staticClass: "order-list"
  }, [(_vm.editabled === false) ? _c('div', {
    staticClass: "order-row-header"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('user_center_order_order_num')) + "：" + _vm._s(_vm.goods.order_sn) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-row"
  }, [_c('div', {}, [(_vm.editabled) ? _c('Checkbox', {
    staticClass: "goods-checkbox",
    attrs: {
      "label": _vm.goods.id
    },
    model: {
      value: (_vm.goods.isSelect),
      callback: function($$v) {
        _vm.$set(_vm.goods, "isSelect", $$v)
      },
      expression: "goods.isSelect"
    }
  }, [_c('div', {
    staticClass: "goods-header"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/profile/app_icon@2x.png"),
      "alt": ""
    }
  })])]) : _c('div', {
    staticClass: "goods-header"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/profile/app_icon@2x.png"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-desc"
  }, [_c('h3', [_vm._v(_vm._s(_vm.goods.goods_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.goods.goodsDesc))])]), _vm._v(" "), _c('div', {
    staticClass: "goods-price"
  }, [_vm._v(_vm._s(_vm.goods.price))]), _vm._v(" "), _c('div', {
    staticClass: "goods-num"
  }, [(_vm.editabled) ? _c('div', {
    staticClass: "goods-num-editable"
  }, [_c('button', {
    staticClass: "minus",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.minus
    }
  }, [_c('Icon', {
    attrs: {
      "type": "minus",
      "size": "12"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.goods.num))]), _vm._v(" "), _c('button', {
    staticClass: "plus",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.plus
    }
  }, [_c('Icon', {
    attrs: {
      "type": "plus",
      "size": "12"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.editabled === false) ? _c('span', [_vm._v(_vm._s(_vm.goods.num))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "goods-price text-primary"
  }, [_vm._v(_vm._s(_vm.goods.price * _vm.goods.num))]), _vm._v(" "), _c('div', {
    staticClass: "goods-operation"
  }, [(_vm.operation === 'exchange') ? _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_center_order_return_exchange')))]) : _vm._e(), _vm._v(" "), (_vm.operation === 'cancel') ? _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close"
    }
  })], 1) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4a37f1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/Common/OrderList.vue
// module id = 855
// module chunks = 0